import { Logic, QuestionAnswer } from "@/types/questions";
import { h } from "preact";
import { useState } from "preact/hooks";
import Clock from "@/assets/icons/clock.svg";
import SlideFooter from "@/components/SlideFooter";
import QuestionContainer from "@/components/QuestionContainer";

interface SliderProps {
  onBack: (selectedAnswer: QuestionAnswer | null) => void;
  onNext: (selectedAnswer: QuestionAnswer) => void;
  questionText: string;
  questionSubText?: string;
  answers: QuestionAnswer[];
  logic?: Logic;
  defaultSelectedAnswers: QuestionAnswer | null;
}

const Slider = ({
  onBack,
  onNext,
  questionText,
  questionSubText,
  answers,
  defaultSelectedAnswers,
}: SliderProps) => {
  const [selectedAnswer, setSelectedAnswer] = useState<QuestionAnswer>(
    defaultSelectedAnswers || answers[0]
  );

  const handleRangeChange = (
    event: h.JSX.TargetedEvent<HTMLInputElement, Event>
  ) => {
    setSelectedAnswer(answers[Number(event.currentTarget.value)]);
  };

  const handleBack = () => {
    onBack(selectedAnswer);
  };

  const handleNext = () => {
    if (selectedAnswer) {
      onNext(selectedAnswer);
    }
  };

  return (
    <>
      <QuestionContainer legendText={questionText} subtext={questionSubText}>
        <div className="lc-flex lc-flex-col lc-w-full lc-self-center lc-items-center lc-gap-16 lc-justify-center lc-max-w-3xl lc-animate-fadeTop">
          <img
            src={Clock}
            width={170}
            height={170}
            alt=""
            className="lc-flex lc-align-middle"
          />
          <div className="lc-w-full lc-flex lc-flex-col lc-gap-8">
            <input
              id="rangeSlider"
              type="range"
              min="0"
              value={answers.indexOf(selectedAnswer)}
              max={answers.length - 1}
              onInput={handleRangeChange}
              className="lc-mx-10 lg:lc-mx-20 lc-h-2 lg:lc-h-[22px] lc-bg-gray-200 lc-rounded-full lc-appearance-none lc-cursor-pointer"
              list="values"
            ></input>
            <div className="lg:lc-px-6 lc-flex lc-w-full lc-flex-row lc-justify-between">
              {answers.map((answer) => (
                <span
                  onClick={() => setSelectedAnswer(answer)}
                  className="lc-cursor-pointer lc-text-white lc-w-16 lg:lc-w-[122px] lc-text-center lc-font-azo-sans lc-text-sm lg:lc-text-base first:lc-ml-4 last:lc-mr-4"
                >
                  {answer.text}
                </span>
              ))}
            </div>
            <datalist id="values" className="sr-only">
              {answers.map((answer, index) => (
                <option value={index} label={answer.text}></option>
              ))}
            </datalist>
          </div>
        </div>
      </QuestionContainer>
      <SlideFooter
        onNext={handleNext}
        onBack={handleBack}
        disableContinue={!selectedAnswer}
      />
    </>
  );
};

export default Slider;
